import { ALL_PATHS } from 'app/shared/consts';

export const sortPaths = (paths: string[]) =>
  paths.sort((pathA, pathB) => {
    const segmentsA = pathA.split('/');
    const segmentsB = pathB.split('/');

    const minLength = Math.min(segmentsA.length, segmentsB.length);
    for (let i = 0; i < minLength; i += 1) {
      const segmentA = segmentsA[i];
      const segmentB = segmentsB[i];

      const isParamA = segmentA.startsWith(':');
      const isParamB = segmentB.startsWith(':');

      // If one is dynamic and other is static, static comes first
      if (isParamA !== isParamB) {
        return isParamA ? 1 : -1;
      }

      // If both are static and different, sort alphabetically
      if (!isParamA && !isParamB && segmentA !== segmentB) {
        return segmentA.localeCompare(segmentB);
      }
    }

    // If all common segments are identical, shorter paths come first
    return segmentsA.length - segmentsB.length;
  });

export const paths = sortPaths([...ALL_PATHS]);
